import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-abilities',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-abilities.component.html',
  styleUrl: './offer-abilities.component.css',
})
export class OfferAbilitiesComponent {
  headerHighlight = input<string>();
  header = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  bold3 = input<string>();
  text3 = input<string>();
  bold4 = input<string>();
  text4 = input<string>();
  bold5 = input<string>();
  text5 = input<string>();
}
